import { render, staticRenderFns } from "./MailEdit.vue?vue&type=template&id=c26c4138&"
import script from "./MailEdit.vue?vue&type=script&lang=js&"
export * from "./MailEdit.vue?vue&type=script&lang=js&"
import style0 from "./MailEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MailEdit.vue"
export default component.exports